<ng-container *ngIf="data.img !== null; else empty">
  <i class="fal fa-image fa-2x vehicle-images-icon" (click)="showImages()" [title]="data.title"></i>
  <div *ngIf="viewImage">
    <img id="image" class="d-none" [src]="data.img" [alt]="data.imgAlt" #image />
  </div>
</ng-container>
<ng-template #empty>-</ng-template>
